module.exports = {"domain":"messages","locale_data":{"messages":{"":{"domain":"messages","plural_forms":"nplurals=2; plural=(n > 1);","lang":"fr"}}}}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/en.json
// module id = 1090
// module chunks = 0